import { useState, useEffect, useMemo, useCallback, useRef } from "react";

export const useInput = (initalValue,mode="string") => {
  const [value, setValue] = useState(initalValue);
  return [
    { value,
      onChange: e => {
        if(mode==='number') {
          let v = e.target.value;
          v = v.replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 65248)).replace(/\D/g, '');
          setValue(v)
        } else if(mode==='english') {
          let v = e.target.value;
          v = v.replace(/[０-９ａ-ｚＡ-Ｚ]/g, s => String.fromCharCode(s.charCodeAt(0) - 65248))
               .replace(/[^a-zA-Z0-9\s/\!\*\@,;:\.\⁼\-\#\"\'\[\]\(\)\&\{\}\<\>\_\?\+\%\$\~]/g, '');
          setValue(v)
        } else {
          setValue(e.target.value)
        }
      },
      //onKeyDown: e => {
      //  if(mode==='kana') {
      //    if (e.key === "Enter" && e.keyCode === 229) {
      //      let v = e.target.value;
      //      v = v.replace(/[ぁ-ゖ]/g, s => String.fromCharCode(s.charCodeAt(0) + 96)).replace(/[^ァ-ー]/g, '');
      //      setValue(v)
      //    }
      //  }
      //},
      onBlur: e => {
        if(mode==='kana') {
          let v = e.target.value;
          v = v.replace(/[ぁ-ゖ]/g, s => String.fromCharCode(s.charCodeAt(0) + 96)).replace(/[^ァ-ー]/g, '');
          setValue(v)
        }
      }
    },
    () => setValue(initalValue),
    (val) => setValue(val)
  ];
}

export const useCheckbox = (initalValue) => {
  const [val, setValue] = useState(initalValue);
  return [
    { val,
      onChange: e => {
        if (val.includes(e.target.value)) {
          setValue(val.filter(item => item !== e.target.value));
        } else {
          setValue([...val, e.target.value]);
        } 
      },
    },
    () => setValue(initalValue),
    (val) => setValue(val),
  ];
}

export const useRadio = (initalValue) => {
  const [val, setValue] = useState(initalValue);
  return [
    { val,
      onChange: e => {
        setValue(e.target.value);
      }
    },
    () => setValue(initalValue),
    (val) => setValue(val),
  ];
}


export function useFetch(uri) {
  const [data, setData] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(true);

  const mounted = useMountedRef();

  useEffect(() => {
    if (!uri) return;
    if (!mounted.current) return;
    setLoading(true);
    fetch(uri)
      .then(data => {
        if (!mounted.current) throw new Error("component is not mounted");
        return data;
      })
      .then(data => data.json())
      .then(setData)
      .then(() => setLoading(false))
      .catch(error => {
        if (!mounted.current) return;
        setError(error)
      });
  }, [uri]);

  return {
    loading,
    data,
    error
  };
}

export const useIterator = (
  items = [],
  initalIndex = 0
) => {
  const [i, setIndex] = useState(initalIndex);

  const prev = useCallback(() => {
    if ( i === 0 ) return setIndex(items.length - 1);
    setIndex(i - 1);
  }, [i,items]);

  const next = useCallback(() => {
    if ( i === items.length - 1) return setIndex(0);
    setIndex( i + 1);
  }, [i,items]);

  const item = useMemo(() => items[i], [i,items]);

  return [item || items[0], prev, next];

};

export function useMountedRef() {
  const mounted = useRef(false);
  useEffect(() => {
    mounted.current = true;
    return () => (mounted.current = false);
  });
  return mounted;
}